import React from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import {
  AccordionButton as ChakraAccordionButton,
  forwardRef,
} from '@chakra-ui/react';

import { AccordionButtonProps } from './types';

const AccordionButton = forwardRef<AccordionButtonProps, 'button'>(
  (props, ref) => <ChakraAccordionButton ref={ref} {...props} />
);

export { AccordionButton };
